export default __webpack_public_path__ + "static/media/refresh-icon.01d18ded.svg";